export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Bold.e8ac3e02.woff";